<template>
  <div class="summary">
    <gl-header icon-name="gr-wallet" title="Network summary" />
    <div class="summary__main">
      <div v-for="(row, index) in prepareData()" :key="index" class="summary__row">
        <p class="summary__title text text--body text--light text-truncate">{{ row.title }}</p>
        <p class="summary__value text text--body text--white text-truncate">{{ row.value }}</p>
      </div>
      <div class="summary__subTable">
        <div v-for="(row, index) in prepareSubData()" :key="index" class="summary__row">
          <p class="summary__title text text--body text--light text-truncate">{{ row.title }}</p>
          <p class="summary__value text text--body text--light text-truncate">{{ row.value }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GlHeader from '@gl/GlHeader'
import { getBlockInfo } from '@/services/api'
import { updatePeriod } from '@/config'

export default {
  name: 'HomeSummary',
  components: { GlHeader },
  data() {
    return {
      timer: null,
      info: {
        blocks: 'Loading...',
        difficulty: 'Loading...',
        networkhashps: 'Loading...',
        defaultfee: 'Loading...',
        totalSupply: 'Loading...',
        availableSupply: 'Loading...',
        holders: 'Loading...',
      },
    }
  },
  mounted() {
    this.loadBlockInfo()
    this.timer = setInterval(() => {
      this.loadBlockInfo()
    }, updatePeriod)
  },
  beforeUnmount() {
    clearInterval(this.timer)
  },
  methods: {
    async loadBlockInfo() {
      const { data } = await getBlockInfo()
      if (data.state === 'success') {
        this.info = data.data
      }
    },
    prepareData() {
      return [
        {
          title: 'Blocks',
          value: this.info.blocks,
        },
        {
          title: 'Difficulty',
          value:
            typeof this.info.difficulty === 'number'
              ? this.info.difficulty.toExponential(5)
              : this.info.difficulty,
        },
        {
          title: 'Hashing Power',
          value: this.info.networkhashps,
        },
        {
          title: 'Default Fee',
          value:
            typeof this.info.defaultfee === 'number'
              ? this.info.defaultfee / 100000000
              : this.info.defaultfee,
        },
        {
          title: 'Total Supply PLC',
          value:
            typeof this.info.totalSupply === 'number'
              ? this.info.totalSupply / 100000000
              : this.info.totalSupply,
        },
        {
          title: 'Available Supply PLC',
          value:
            typeof this.info.availableSupply === 'number'
              ? this.info.availableSupply / 100000000
              : this.info.availableSupply,
        },
      ]
    },
    prepareSubData() {
      return [
        {
          title: 'PLC Total Turnover',
          value: 'Coming soon',
        },

        {
          title: 'Active blockchain places',
          value: 'Coming soon',
        },

        {
          title: 'Blockchain places reward',
          value: 'Coming soon',
        },
      ]
    },
  },
}
</script>

<style lang="scss">
.summary {
  &__main {
    background-color: rgba(255, 255, 255, 0.07);
    padding: 32px 16px 16px;
  }

  &__row {
    @media (min-width: $breakpoint-md) {
      display: flex;
    }

    & + & {
      margin-top: 16px;
    }
  }

  &__title,
  &__value {
    flex: 1;
  }

  &__btn {
    margin-top: 32px;
    width: 100%;
  }

  &__subTable {
    border: $border;
    margin-top: 16px;
    padding: 16px;
  }
}
</style>
